export default __webpack_public_path__ + "static/media/developer-guidance.15c72a1c.svg";